import { request } from "../lib/requestHelper"

 /* AUTH / USER */
 export const fetchUserApi = () =>
   request("user/get-user", {
     method: "GET",
   })

 export const logoutUserApi = () =>
   request("auth/log-out", {
     method: "POST",
   })

 export const changePasswordApi = (data) =>
   request("auth/change-password", {
     method: "POST",
     body: JSON.stringify(data),
   })

 export const deleteAccountApi = () =>
   request("auth/delete-account", {
     method: "DELETE",
   })

 /* PROFILE */
 export const fetchUserProfileApi = () =>
   request("user/get-user-profile-details")

 export const fetchArtisanProfileApi = () =>
   request("artisan/get-artisan-profile-details")

 /* ROLE */
 export const switchRoleApi = (role) =>
   request("api/switch-role", {
     method: "POST",
     body: JSON.stringify({ role }),
   })

 /* FOLLOWED ARTISANS */
 export const fetchFollowedArtisansApi = () =>
   request("user/get-followed-artisans")

 export const fetchAllBidsReceivedApi = () =>
   request("user/fetch-all-bids-received")

 export const upgradeToArtisanApi = (data) =>
   request("api/upgrade-to-artisan", {
     method: "POST",
     body: JSON.stringify({ data }),
   })

 export const subscribeUserApi = (email) =>
   request("api/subscribe-user", {
     method: "POST",
     body: JSON.stringify({ email }),
   })

 export const addReviewApi = (data) =>
   request("user/add-review", {
     method: "POST",
     body: JSON.stringify(data),
   })

 export const updateBookingAgreementApi = (bookingId, data) =>
   request(`user/update-booking-agreement/${bookingId}`, {
     method: "PUT",
     body: JSON.stringify(data),
   })

 export const fetchBookingByIdApi = (bookingId, userId) =>
   request(`user/fetch-booking/${bookingId}/${userId}`)

 export const acceptBookingApi = (bookingId) =>
   request(`artisan/accept-booking/${bookingId}`, {
     method: "PUT",
   })
